/// <amd-module name="Artifacts/Cargo/components/CargoPackageOverview" />
import { getCopyInstallCommand } from "Artifacts/Cargo/helpers/InstructionsHelper";
import * as CargoRes from "Artifacts/Cargo/Resources";
import { PackageDeletedMessageCard } from "Artifacts/Package/components/package-details-common/PackageDeletedMessageCard";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Button } from "VSSUI/Button";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

const CargoOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const history = useHistory();

  return (
    <div className="package-overview-content">
      {version.isDeleted && (
        <PackageDeletedMessageCard version={version.version} packageName={pkg.name} />
      )}
      {!version.isDeleted && !version.isListed && (
        <MessageCard severity={MessageCardSeverity.Warning} className="message-card">
          <FormatComponent format={CargoRes.PackageUnlistedMessage}>
            {version.version}
            {pkg.name}
          </FormatComponent>
        </MessageCard>
      )}
      {!version.isDeleted && (
        <PackageTile title={PackageRes.PackageDetails_GetThisPackage}>
          <div className="package-command">
            <Button
              iconProps={{
                iconName: "PlugConnected",
              }}
              onClick={() => {
                feed && history.push(generatePath(connectToFeed, { feedIdentifier: feed.name }));
              }}
            >
              {RootRes.ConnectToFeedButton}
            </Button>
            <span className="install-instructions-then">
              {PackageRes.PackageDetails_InstallInstructions_then}
            </span>
            <CopyableTextField text={getCopyInstallCommand(pkg.name, version)}></CopyableTextField>
          </div>
        </PackageTile>
      )}
      <PackageTile title={PackageRes.PackageDetails_Description}>
        <div className="package-description">{version.description}</div>
      </PackageTile>
    </div>
  );
};

export { CargoOverview };
